/**
 * Created by Jonas Wålekvist on 2018-09-26.
 */

export class Matrix<T> {

    private _matrix:T[][];
    private _width:number;
    private _height:number;

    constructor(width:number, height:number, initValue:T) {
        this._width = width;
        this._height = height;
        this.reset();
        this.populate(initValue);
    }

    public populate(item:T) {
        for(let reelIndex = 0; reelIndex < this._matrix.length; reelIndex++) {
            for(let symbolIndex = 0; symbolIndex < this._matrix[reelIndex].length; symbolIndex++) {
                this.addItemAt(item, reelIndex, symbolIndex);
            }
        }
    }

    public addItemAtPosition(item:T, position:[number, number]) {
        this._matrix[position[0]][position[1]] = item;
    }

    public addItemAt(item:T, col:number, row:number) {
        this._matrix[col][row] = item;
    }

    public getItemAt(col:number, row:number):T {
        return this._matrix[col][row];
    }

    public getItemAtPosition(position:[number, number]):T {
        return this._matrix[position[0]][position[1]];
    }

    public getAllItems():T[] {
        const result:T[] = [];
        for(let i:number = 0; i < this._width; i++) {
            for(let j:number = 0; j < this._height; j++) {
                if(this._matrix[i][j]) {
                    result.push(this._matrix[i][j]);
                }
            }
        }
        return result;

    }

    public getAllInColumn(index:number):T[] {
        const result:T[] = [];
        for(let i:number = 0; i < this._matrix[index].length; i++) {
            if(this._matrix[index][i]) {
                result.push(this._matrix[index][i]);
            }
        }
        return result;
    }

    public getAllInRow(index:number):T[] {
        const result:T[] = [];
        for(let i:number = 0; i < this._matrix.length; i++) {
            if(this._matrix[i][index]) {
                result.push(this._matrix[i][index]);
            }
        }
        return result;
    }


    public reset() {
        this._matrix = [];
        for(let i:number = 0; i < this._width; i++) {
            this._matrix.push(new Array(this._height));
        }
    }
}